// Initialize Flatpickr calendar for delivery date selection
document.addEventListener('DOMContentLoaded', function() {
  const deliveryDateInput = document.getElementById('delivery-date');

  if (deliveryDateInput && typeof flatpickr !== 'undefined') {
    flatpickr(deliveryDateInput, {
      minDate: 'today',
      dateFormat: 'Y-m-d',
      disableMobile: true, // Force desktop calendar even on mobile
      onChange: function(selectedDates, dateStr, instance) {
        // Update the cart attribute when date changes
        if (dateStr) {
          updateCartAttribute('Preferred Delivery Date', dateStr);
        }
      }
    });
  }
});

// Function to update cart attributes via AJAX
function updateCartAttribute(key, value) {
  const formData = {
    attributes: {
      [key]: value
    }
  };

  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .catch(error => console.error('Error updating cart attribute:', error));
}
